import {
  useState
} from "react";

import {
  useParams,useHistory
} from "react-router-dom";

import useProductDetail
from "../hooks/useProductDetail";

import useProductPlans
from "../hooks/useProductPlans";

import ProductHero
from "../components/ProductHero";

import PlanSelector
from "../components/PlanSelector";

import EmptyState
from "../components/EmptyState";

export default function ProductDetailPage() {

  const {
    productId
  } = useParams();
 const history =useHistory()
  const {

    product,

    loading,

    error

  } =
    useProductDetail(
      productId
    );

  const {

    plans

  } =
    useProductPlans(
      productId
    );

  const [

    selectedPlan,

    setSelectedPlan

  ] = useState(null);

  if (loading) {

    return (

      <EmptyState
        title="Loading..."
      />

    );

  }

  if (error) {

    return (

      <EmptyState

        title="Error"

        subtitle={error}

      />

    );

  }

  if (!product) {

    return (

      <EmptyState

        title="Product not found"

      />

    );

  }

  function handleBuy() {

  history.push(

  `/checkout/${
    product.id
  }/${
    selectedPlan.id
  }`

);
  }

  return (

    <div
      style={styles.page}
    >

      <ProductHero
        product={product}
      />

      <PlanSelector

        plans={plans}

        onSelect={
          setSelectedPlan
        }

      />

      <button

        disabled={
          !selectedPlan
        }

        onClick={
          handleBuy
        }

        style={

          selectedPlan

            ? styles.buyButton

            : styles.disabledButton

        }

      >

        Buy Now

      </button>

    </div>

  );

}

const styles = {

  page: {

    maxWidth: 1400,

    margin: "0 auto", marginTop:"70px",

    padding: 24

  },

  buyButton: {

    width: "100%",

    height: 60,

    marginTop: 32,

    border: "none",

    borderRadius: 20,

    background:
      "#111827",

    color: "#fff",

    fontWeight: 700,

    fontSize: 16,

    cursor: "pointer"

  },

  disabledButton: {

    width: "100%",

    height: 60,

    marginTop: 32,

    border: "none",

    borderRadius: 20,

    background:
      "#d1d5db",

    color: "#fff"

  }

};